import React from "react"
import { Form, Button } from "antd"
import SiteSurveysMotorsFormPiece from "./SiteSurveysMotorsFormPiece"
import { PlusOutlined } from "@ant-design/icons"

function SiteSurveysMotorsForm(props) {
    /////*** event handler methods start ***/////
    const handleRemove = (field, remove) => {
        let allValues = props.form.getFieldValue()
        if (!!allValues.motors_attributes[field.name]) {
            if (!!allValues.motors_attributes[field.name]["site_survey_id"]) {
                let updatedFieldsToRemove = [...props.toRemove]
                updatedFieldsToRemove.push({ ...allValues.motors_attributes[field.name], _destroy: true })
                props.setToRemove(updatedFieldsToRemove)
            }
        }
        remove(field.name)
    }
    /////*** event handler methods end ***/////

    return (
        <div id={"site-surveys-motors-form"} className={"card"}>
            <Form.List name={"motors_attributes"}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field) => (
                            <SiteSurveysMotorsFormPiece {...field} key={field.key} remove={() => handleRemove(field, remove)} />
                        ))}
                        <Form.Item className={"add-field"}>
                            <Button block onClick={() => add()} icon={<PlusOutlined />}>
                                Add field
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>
    )
}

export default SiteSurveysMotorsForm
